import { Patient } from '../model/patient.model';

export const patientFactory = {
  create: (id, externalId, name, lastName, email, allergens = [], disliked = []) => {
    return new Patient(id, externalId, name, lastName, email, allergens, disliked);
  },
};
